<div class="modal-body">
  <p class="centermodal__title">{{ 'auth.selectAuthenticationMethod' | translate }}</p>
  <p class="centermodal__description">{{ 'auth.selectAuthenticationDescriptionDocument' | translate }}</p>

  <div class="centermodal__form">
    <input type="hidden" ngbAutofocus />
    <button type="button" class="btn-L btn-outline btn-outline-neutral icon-start d-flex mt-2 mx-auto" (click)="selectBiometric()">
      <i class="fa-regular fa-face-viewfinder"></i>
      <span>{{ 'auth.continueWithBiometric' | translate }}</span>
    </button>

    <p class="centermodal__separator">
      <span>{{ 'auth.orAccessYourAccount' | translate }}</span>
    </p>

    <button type="button" class="btn-L btn-outline btn-outline-neutral icon-start d-flex mx-auto" (click)="selectEmail()">
      <i class="fa-solid fa-envelope"></i>
      <span>{{ 'auth.continueWithEmail' | translate }}</span>
    </button>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled btn-filled-cancel" (click)="modal.dismiss()">
      {{ 'button.cancel' | translate }}
    </button>
  </div>
</div>
